import React from "react";

export default () => {
  return (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M49.5 1.20711L1.20711 49.5H47C48.3807 49.5 49.5 48.3807 49.5 47V1.20711Z" fill="#428600" stroke="#428600" />
      <path d="M41.9232 30.1538L33.4024 37.8461L29.6155 34.4275" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
